import React, {useState } from 'react';

const ReadyScreen = ({ onNext }) => {
  const [micStatus, setMicStatus] = useState(null); // null | 'success' | 'error' | 'testing'

  const handleTestMic = async () => {
    setMicStatus('testing');
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicStatus('success');
      // Stop all tracks immediately after test
      stream.getTracks().forEach(track => track.stop());
    } catch (e) {
      setMicStatus('error');
    }
  };

  return (
    <div className="content-area">
      {/* Main content */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '25px',
        padding: '20px',
        flex: 1,
        // justifyContent: 'center'
      }}>
        {/* Video placeholder - same as home screen */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <div className="" style={{ position: 'relative', width: 320, height: 568, background: '#eee', borderRadius: 12, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/z3ooekzAIDc"
              title="YouTube Shorts video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{ border: 0 }}
            ></iframe>
          </div>

          {/* Ready section */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '5px',
            // width: '50%',
            maxWidth: '50%',
            padding: '20px 40px'
          }}>
            {/* READY button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                className="btn-primary btn-large"
                onClick={onNext}
                style={{ width: '171px' }}
              >
                READY
              </button>
            </div>

            {/* Microphone test section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
              {/* Microphone icon */}
              <svg
                className="mic-icon"
                width="28"
                height="28"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M12.5 14C11.6667 14 10.9583 13.7083 10.375 13.125C9.79167 12.5417 9.5 11.8333 9.5 11V5C9.5 4.16667 9.79167 3.45833 10.375 2.875C10.9583 2.29167 11.6667 2 12.5 2C13.3333 2 14.0417 2.29167 14.625 2.875C15.2083 3.45833 15.5 4.16667 15.5 5V11C15.5 11.8333 15.2083 12.5417 14.625 13.125C14.0417 13.7083 13.3333 14 12.5 14ZM11.5 21V17.925C9.76667 17.6917 8.33333 16.9167 7.2 15.6C6.06667 14.2833 5.5 12.75 5.5 11H7.5C7.5 12.3833 7.9875 13.5625 8.9625 14.5375C9.9375 15.5125 11.1167 16 12.5 16C13.8833 16 15.0625 15.5125 16.0375 14.5375C17.0125 13.5625 17.5 12.3833 17.5 11H19.5C19.5 12.75 18.9333 14.2833 17.8 15.6C16.6667 16.9167 15.2333 17.6917 13.5 17.925V21H11.5Z"
                  fill="#1D1B20"
                />
              </svg>
              <button
                onClick={handleTestMic}
                style={{
                  fontFamily: 'var(--font-albert)',
                  fontSize: '16px',
                  fontWeight: 500,
                  padding: 0,
                  border: 'none',
                  background: 'none',
                  color: '#111',
                  cursor: 'pointer',
                  marginLeft: 8,
                  textDecoration: 'none',
                  outline: 'none',
                }}
                disabled={micStatus === 'testing'}
              >
                {micStatus === 'testing' ? 'Testing...' : 'Test Microphone'}
              </button>
              {micStatus === 'success' && (
                <span style={{ color: 'green', marginLeft: 10, fontWeight: 500 }}>Mic working!</span>
              )}
              {micStatus === 'error' && (
                <span style={{ color: 'red', marginLeft: 10, fontWeight: 500 }}>Mic not detected</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadyScreen;
